/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AccesoRouteImport } from './routes/acceso'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as PosicionesIndexRouteImport } from './routes/posiciones.index'
import { Route as PostulacionConfirmacionRouteImport } from './routes/postulacion.confirmacion'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminEquipoRouteImport } from './routes/_authenticated/admin.equipo'
import { Route as PosicionesIdIndexRouteImport } from './routes/posiciones.$id.index'
import { Route as PosicionesIdPostularRouteImport } from './routes/posiciones.$id.postular'
import { Route as AuthenticatedAdminPosicionesIndexRouteImport } from './routes/_authenticated/admin.posiciones.index'
import { Route as AuthenticatedAdminPosicionesIdRouteImport } from './routes/_authenticated/admin.posiciones.$id'
import { Route as AuthenticatedAdminPostulacionesIndexRouteImport } from './routes/_authenticated/admin.postulaciones.index'
import { Route as AuthenticatedAdminPostulacionesIdRouteImport } from './routes/_authenticated/admin.postulaciones.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AccesoRoute = AccesoRouteImport.update({
  id: '/acceso',
  path: '/acceso',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const PosicionesIndexRoute = PosicionesIndexRouteImport.update({
  id: '/posiciones/',
  path: '/posiciones/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostulacionConfirmacionRoute = PostulacionConfirmacionRouteImport.update({
  id: '/postulacion/confirmacion',
  path: '/postulacion/confirmacion',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminEquipoRoute =
  AuthenticatedAdminEquipoRouteImport.update({
    id: '/equipo',
    path: '/equipo',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const PosicionesIdIndexRoute = PosicionesIdIndexRouteImport.update({
  id: '/posiciones/$id/',
  path: '/posiciones/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const PosicionesIdPostularRoute = PosicionesIdPostularRouteImport.update({
  id: '/posiciones/$id/postular',
  path: '/posiciones/$id/postular',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminPosicionesIndexRoute =
  AuthenticatedAdminPosicionesIndexRouteImport.update({
    id: '/posiciones/',
    path: '/posiciones/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminPosicionesIdRoute =
  AuthenticatedAdminPosicionesIdRouteImport.update({
    id: '/posiciones/$id',
    path: '/posiciones/$id',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminPostulacionesIndexRoute =
  AuthenticatedAdminPostulacionesIndexRouteImport.update({
    id: '/postulaciones/',
    path: '/postulaciones/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminPostulacionesIdRoute =
  AuthenticatedAdminPostulacionesIdRouteImport.update({
    id: '/postulaciones/$id',
    path: '/postulaciones/$id',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/acceso': typeof AccesoRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/postulacion/confirmacion': typeof PostulacionConfirmacionRoute
  '/posiciones/': typeof PosicionesIndexRoute
  '/admin/equipo': typeof AuthenticatedAdminEquipoRoute
  '/posiciones/$id/postular': typeof PosicionesIdPostularRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/posiciones/$id/': typeof PosicionesIdIndexRoute
  '/admin/posiciones/$id': typeof AuthenticatedAdminPosicionesIdRoute
  '/admin/postulaciones/$id': typeof AuthenticatedAdminPostulacionesIdRoute
  '/admin/posiciones/': typeof AuthenticatedAdminPosicionesIndexRoute
  '/admin/postulaciones/': typeof AuthenticatedAdminPostulacionesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/acceso': typeof AccesoRoute
  '/postulacion/confirmacion': typeof PostulacionConfirmacionRoute
  '/posiciones': typeof PosicionesIndexRoute
  '/admin/equipo': typeof AuthenticatedAdminEquipoRoute
  '/posiciones/$id/postular': typeof PosicionesIdPostularRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/posiciones/$id': typeof PosicionesIdIndexRoute
  '/admin/posiciones/$id': typeof AuthenticatedAdminPosicionesIdRoute
  '/admin/postulaciones/$id': typeof AuthenticatedAdminPostulacionesIdRoute
  '/admin/posiciones': typeof AuthenticatedAdminPosicionesIndexRoute
  '/admin/postulaciones': typeof AuthenticatedAdminPostulacionesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/acceso': typeof AccesoRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/postulacion/confirmacion': typeof PostulacionConfirmacionRoute
  '/posiciones/': typeof PosicionesIndexRoute
  '/_authenticated/admin/equipo': typeof AuthenticatedAdminEquipoRoute
  '/posiciones/$id/postular': typeof PosicionesIdPostularRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/posiciones/$id/': typeof PosicionesIdIndexRoute
  '/_authenticated/admin/posiciones/$id': typeof AuthenticatedAdminPosicionesIdRoute
  '/_authenticated/admin/postulaciones/$id': typeof AuthenticatedAdminPostulacionesIdRoute
  '/_authenticated/admin/posiciones/': typeof AuthenticatedAdminPosicionesIndexRoute
  '/_authenticated/admin/postulaciones/': typeof AuthenticatedAdminPostulacionesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/acceso'
    | '/admin'
    | '/postulacion/confirmacion'
    | '/posiciones/'
    | '/admin/equipo'
    | '/posiciones/$id/postular'
    | '/admin/'
    | '/posiciones/$id/'
    | '/admin/posiciones/$id'
    | '/admin/postulaciones/$id'
    | '/admin/posiciones/'
    | '/admin/postulaciones/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/acceso'
    | '/postulacion/confirmacion'
    | '/posiciones'
    | '/admin/equipo'
    | '/posiciones/$id/postular'
    | '/admin'
    | '/posiciones/$id'
    | '/admin/posiciones/$id'
    | '/admin/postulaciones/$id'
    | '/admin/posiciones'
    | '/admin/postulaciones'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/acceso'
    | '/_authenticated/admin'
    | '/postulacion/confirmacion'
    | '/posiciones/'
    | '/_authenticated/admin/equipo'
    | '/posiciones/$id/postular'
    | '/_authenticated/admin/'
    | '/posiciones/$id/'
    | '/_authenticated/admin/posiciones/$id'
    | '/_authenticated/admin/postulaciones/$id'
    | '/_authenticated/admin/posiciones/'
    | '/_authenticated/admin/postulaciones/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AccesoRoute: typeof AccesoRoute
  PostulacionConfirmacionRoute: typeof PostulacionConfirmacionRoute
  PosicionesIndexRoute: typeof PosicionesIndexRoute
  PosicionesIdPostularRoute: typeof PosicionesIdPostularRoute
  PosicionesIdIndexRoute: typeof PosicionesIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/acceso': {
      id: '/acceso'
      path: '/acceso'
      fullPath: '/acceso'
      preLoaderRoute: typeof AccesoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/posiciones/': {
      id: '/posiciones/'
      path: '/posiciones'
      fullPath: '/posiciones/'
      preLoaderRoute: typeof PosicionesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/postulacion/confirmacion': {
      id: '/postulacion/confirmacion'
      path: '/postulacion/confirmacion'
      fullPath: '/postulacion/confirmacion'
      preLoaderRoute: typeof PostulacionConfirmacionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/equipo': {
      id: '/_authenticated/admin/equipo'
      path: '/equipo'
      fullPath: '/admin/equipo'
      preLoaderRoute: typeof AuthenticatedAdminEquipoRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/posiciones/$id/': {
      id: '/posiciones/$id/'
      path: '/posiciones/$id'
      fullPath: '/posiciones/$id/'
      preLoaderRoute: typeof PosicionesIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posiciones/$id/postular': {
      id: '/posiciones/$id/postular'
      path: '/posiciones/$id/postular'
      fullPath: '/posiciones/$id/postular'
      preLoaderRoute: typeof PosicionesIdPostularRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin/posiciones/': {
      id: '/_authenticated/admin/posiciones/'
      path: '/posiciones'
      fullPath: '/admin/posiciones/'
      preLoaderRoute: typeof AuthenticatedAdminPosicionesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/posiciones/$id': {
      id: '/_authenticated/admin/posiciones/$id'
      path: '/posiciones/$id'
      fullPath: '/admin/posiciones/$id'
      preLoaderRoute: typeof AuthenticatedAdminPosicionesIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/postulaciones/': {
      id: '/_authenticated/admin/postulaciones/'
      path: '/postulaciones'
      fullPath: '/admin/postulaciones/'
      preLoaderRoute: typeof AuthenticatedAdminPostulacionesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/postulaciones/$id': {
      id: '/_authenticated/admin/postulaciones/$id'
      path: '/postulaciones/$id'
      fullPath: '/admin/postulaciones/$id'
      preLoaderRoute: typeof AuthenticatedAdminPostulacionesIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminEquipoRoute: typeof AuthenticatedAdminEquipoRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminPosicionesIdRoute: typeof AuthenticatedAdminPosicionesIdRoute
  AuthenticatedAdminPostulacionesIdRoute: typeof AuthenticatedAdminPostulacionesIdRoute
  AuthenticatedAdminPosicionesIndexRoute: typeof AuthenticatedAdminPosicionesIndexRoute
  AuthenticatedAdminPostulacionesIndexRoute: typeof AuthenticatedAdminPostulacionesIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminEquipoRoute: AuthenticatedAdminEquipoRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminPosicionesIdRoute: AuthenticatedAdminPosicionesIdRoute,
  AuthenticatedAdminPostulacionesIdRoute:
    AuthenticatedAdminPostulacionesIdRoute,
  AuthenticatedAdminPosicionesIndexRoute:
    AuthenticatedAdminPosicionesIndexRoute,
  AuthenticatedAdminPostulacionesIndexRoute:
    AuthenticatedAdminPostulacionesIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AccesoRoute: AccesoRoute,
  PostulacionConfirmacionRoute: PostulacionConfirmacionRoute,
  PosicionesIndexRoute: PosicionesIndexRoute,
  PosicionesIdPostularRoute: PosicionesIdPostularRoute,
  PosicionesIdIndexRoute: PosicionesIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
